import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	overflow: auto;

	button {
		font-size: 1.4rem;
		font-family: 'nunito-regular';
	}
`;
